import type { MyVoucher } from '@/types/jobPaymentTypes';
import { formatVoucherDiscount } from '@/utils/vouchers';
import { useTranslation } from 'react-i18next';

type Props = {
  vouchers: MyVoucher[];
  selectedCode?: string | null;
  disabled?: boolean;
  onSelect: (code: string) => void;
  /** Dark panel (provider proposal form) vs light (client payment). */
  variant?: 'light' | 'dark';
};

export default function AssignedVoucherPicker({
  vouchers,
  selectedCode,
  disabled,
  onSelect,
  variant = 'light',
}: Props) {
  const { t } = useTranslation();

  if (!vouchers.length) return null;

  const isDark = variant === 'dark';

  return (
    <div className="mt-3">
      <p
        className={`text-xs mb-2 ${isDark ? 'text-white/75' : 'text-gray-600'}`}
      >
        {t('my_vouchers_use_assigned')}
      </p>
      <div className="flex flex-wrap gap-2">
        {vouchers.map((voucher) => {
          const code = voucher.code.toUpperCase();
          const isSelected = selectedCode?.toUpperCase() === code;
          return (
            <button
              key={voucher._id}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(code)}
              className={`rounded-full px-3 py-1.5 text-sm border transition-colors disabled:opacity-50 ${
                isSelected
                  ? isDark
                    ? 'bg-white text-black border-white'
                    : 'bg-darkBlue text-white border-darkBlue'
                  : isDark
                    ? 'bg-transparent text-white border-white/40 hover:border-white'
                    : 'bg-white text-darkBlue border-darkBlue/40 hover:border-darkBlue'
              }`}
            >
              <span className="font-semibold">{code}</span>
              <span className="opacity-80"> · {formatVoucherDiscount(voucher)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
